import initialState from "./initial"
import {List, fromJS} from "immutable"

const recordingsReducer = (state = initialState.recordings, action) => {
    if (action.type === "RECORDINGS_LOADING") {
        return state.set("loading", true)
    }
    if (action.type === "RECORDINGS_LOADERROR") {
        return state
            .set("data", List([]))
            .set("loaded", false)
            .set("loading", false)
            .set("loaderror", action.msg)
    }
    if (action.type === "RECORDINGS_LOADED") {
        state = state
            .set("data", fromJS(action.data))
            .set("loaded", true)
            .set("loading", false)
            .set("loaderror", "")
        return state
    }
    return state
}

export default recordingsReducer
